export enum BannerType {
  Home = 'home',
  Game = 'game',
  News = 'news',
  Promotion = 'promotion',
  BrandBanner = 'homebrand',
}
